import notify from "devextreme/ui/notify";
import { ApiError } from "../../components/utils/models/api-error";
import { HttpErrorResponse } from "@angular/common/http";

export class UtilityFunctions {
    public static showErrorMessage(errorResponse: HttpErrorResponse) {
        console.log(errorResponse);
        var error = errorResponse.error as ApiError;
        var message = '';
        if (error.type === 'https://tools.ietf.org/html/rfc7231#section-6.5.1') {
            message = `Status ${error.status}: ${error.title}`;
            if (error.errors != undefined) {
                Object.keys(error.errors).forEach(key => {
                    message += `\r\n${key}: ${error.errors[key].join(', ')}`;
                });
            }
        } else if (error.errors != undefined) {
          Object.values(error.errors).forEach(value => {
              message += `\r\n${value}`;
          });
      } else {
            message = errorResponse.message;
        }
        this.showMessage(message, "error");
    }
    public static showMessage(message: string, type: string, duration : number = 3000) {
        notify({
            message: message,
            position: {
                my: 'center top',
                at: 'center top',
            },
        }, type, duration);
    }
}
